module.exports = __webpack_public_path__ + "img/2.a35e0c81.jpg";